interface CreatingState {
  ids: string[]
  isCreating: boolean
}

interface GraphRootState {
  graph?: {
    creating?: CreatingState
  }
}

const defaultCreatingState: CreatingState = {
  ids: [],
  isCreating: false,
}


const selectCreating = (state: Record<string, unknown>): CreatingState => {
  const graph = (state as GraphRootState).graph
  return graph?.creating ?? defaultCreatingState
}

export default selectCreating
